import WebPlayer from './WebPlayer.js';
import WebNotifier from './WebNotifier.js';
import AndroidWebPlayer from './AndroidWebPlayer.js';
import TrackQueue from './TrackQueue.js';
import { api } from './API.js';
import EventBus from './EventBus.js';
import AndroidAPI from './AndroidAPI.js';
import iosApi from './IOSAPI.js';

import Cookie from 'js-cookie';

export default class App {
    constructor(rootComponent) {
        console.log('Pristine Player V2', this);

        this.root = rootComponent;


        var androidApi = new AndroidAPI();

        if (androidApi.supported) {
            console.log('ANDROID API DETECTED');
            this.webPlayer = new AndroidWebPlayer(androidApi);
        } else if(iosApi.supported) {
            console.log('IOS API DETECTED');
            this.webPlayer = new AndroidWebPlayer(iosApi);
            this.root.isIos = true;
        } else {
            console.log('ANDROID API NOT DETECTED');
            this.webPlayer = new WebPlayer;
        }
        this.notifier = null;
        if (!androidApi.supported) {
            this.notifier = WebNotifier;
        }

        this.eventBus = EventBus;
        this.queue = TrackQueue;

        this.root.flacSupported = this.webPlayer.canPlayFlac;
        this.root.flac = this.root.flacSupported;

        this.preloadedTrack = null;
        this.preloadedTrackUri = null;
        this.preloadedFlacSupport = false;



        // Core events

        EventBus.on('core.queue.add', (e) => {
            let track = e.data.track;
        });

        EventBus.on('core.track.play', (e) => {
            this.playTrack(e.data.track, e.data.context, e.data.mode, e.data.stayPaused);
        });

        EventBus.on('core.queue.removeTrack', (e) => {
            this.queue.remove(e.data.mode, e.data.index);
        });

        EventBus.on('core.queue.addTrack', (e) => {
            this.queue.add(e.data.track, e.data.next);
            if (!this.queue.current) {

            }
        });


        // Account
        EventBus.on('account.freePlaysChanged', (e) => {
            this.root.account.freePlays = e.data.freePlays;
        });

        EventBus.on('auth.success', (e) => {
            if (e.data.account) {
                this.root.account.id = e.data.account.id;
                this.root.account.name = e.data.account.name;
                this.root.account.plan = e.data.account.plan;
            } else {
                this.root.account.id = '';
                this.root.account.name = '';
                this.root.account.plan = '';
            }
        });


        // Queue cycle
        this.queue.on('changed', () => {
            console.log('current', this.queue.current);
            if (this.queue.current != null
                    && this.root.playback.track != this.queue.current
                    && !this.queue.current.album) {
                api.get('/tracks/{{id}}', {
                    id: this.queue.current.id,
                }, {
                    with: ['album']
                }, (data) => {
                    this.root.playback.track = data.track;
                    this.queue.serialize();
                });
            } else {
                this.queue.serialize();
            }

            this.root.playback.track = this.queue.current;
            this.root.queue = this.queue.items;
            this.root.history = this.queue.history;
        });


        // Controls

        EventBus.on('controls.togglePause', (e) => {
            if (this.root.playback.playing) {
                this.webPlayer.pause();
            } else {
                this.webPlayer.play();
            }
        });

        EventBus.on('controls.setVolume', (e) => {
            this.webPlayer.setVolume(e.data.volume / 100);
        });

        EventBus.on('controls.setPosition', (e) => {
            if (e.data.type != 'seek') { return; }

            this.webPlayer.seekPercent(e.data.position);
        });

        EventBus.on('controls.playModeChanged', (e) => {
            this.root.playmode.shuffle = e.data.shuffle;
            this.root.playmode.repeat = e.data.repeat;

            if (e.data.shuffle) {
                console.log('IMPLICIT SHUFFLE');
                this.queue.shuffle();
            } else {
                console.log('IMPLICIT UNSHUFFLE');
                this.queue.unshuffle();
            }
        });

        var firstQualityChange = true;
        EventBus.on('controls.setQuality', (e) => {
            console.log('e.data.flac', e.data.flac);
            console.log('root.playback.flac', this.root.playback.flac);
            if (!this.root.playback.flac == !e.data.flac) {
                this.root.playback.flac = e.data.flac;
                return;
            }
            this.root.playback.flac = e.data.flac;

            console.log('QUALITY CHANGE', this.queue);

            if (this.queue.current) {
                var position = this.webPlayer.getPosition();
                var format = this.root.playback.flac ? 'flac' : 'mp3';

                api.get('/listen/{{id}}', {
                    id: this.queue.current.id,
                }, {}, (data) => {
                    var sources = data.sources;
                    this.webPlayer.changeSource(sources[format], this.root.playback.track);
                    this.webPlayer.seek(position);
                    if (!firstQualityChange) {
                        this.webPlayer.play();
                    }
                    firstQualityChange = false;

                    this.root.flacSupportedTrack = sources.flac != null;

                    if (this.queue.items.length > 0) {
                        api.get('/listen/{{id}}', {
                            id: this.queue.items[0].id,
                        }, {
                            type: 'preload',
                        }, (data) => {
                            var sources = data.sources;
                            this.webPlayer.prepareNext(sources[format]);

                            this.preloadedTrack = this.queue.items[0];
                            this.preloadedTrackUri = sources[format];
                            this.preloadedFlacSupport = sources.flac != null;
                        });
                    }
                });
            }
        });

        EventBus.on('controls.next', (e) => {
            this.nextTrack(true);
        });

        EventBus.on('controls.previous', (e) => {
            this.prevTrack(true);
        });



        // Plaback hooks

        this.webPlayer.on('playback.start', (e) => {
            this.root.playback.playing = true;
        });

        this.webPlayer.on('playback.pause', (e) => {
            this.root.playback.playing = false;
        });

        this.webPlayer.on('playback.end', (e) => {
            this.nextTrack();
        });

        this.webPlayer.on('playback.position', (e) => {
            this.root.playback.position = e.data.position;
            this.root.playback.positionSeconds = e.data.positionSeconds;
            this.root.playback.duration = e.data.duration;

            EventBus.emit('controls.setPosition', {
                position: e.data.position,
                positionSeconds: e.data.positionSeconds,
                duration: e.data.duration,
                type: 'playback'
            });
        });


        // Init

        EventBus.on('app.load', (e) => {
            var vol = Cookie.get('pp-volume');
            if (!vol) {
                vol = 0.5;
            }
            console.log(vol);
            EventBus.emit('controls.setVolume', {
                volume: vol * 100
            });

            EventBus.emit('controls.setQuality', {
                flac: this.root.flac
            });

            // this.queue.deserialize();

        });
    }

    playTrack(track, context, mode, stayPaused) {
        console.log('PLAY TRACK', track);

        this.queue.initContext(track, context, mode);
        if (this.root.playmode.shuffle) {
            this.queue.shuffle();
        }

        // this.webPlayer.stop();

        this._loadTrack(track, stayPaused);
    }

    _loadTrack(track, stayPaused) {
        console.log('stayPaused', stayPaused);
        var format = this.root.playback.flac ? 'flac' : 'mp3';

        console.log({
            preload: this.preloadedTrack,
            track,
        });
        if (track == this.preloadedTrack) {
            console.log('App: Skipping listen call, already preloaded');
            this.webPlayer.changeSource(this.preloadedTrackUri, this.root.playback.track);
            if (!stayPaused) {
                this.webPlayer.play();
            }

            this.root.flacSupportedTrack = this.preloadedFlacSupport;


            if (this.notifier) {
                this.notifier.notifyTrackPlaying(track);
            }

            if (this.queue.items.length > 0) {
                api.get('/listen/{{id}}', {
                    id: this.queue.items[0].id,
                }, {
                    type: 'preload',
                }, (data) => {
                    var sources = data.sources;
                    if (sources[format]) {
                        this.webPlayer.prepareNext(sources[format]);

                        this.preloadedTrack = this.queue.items[0];
                        this.preloadedTrackUri = sources[format];
                        this.preloadedFlacSupport = sources.flac != null;
                    } else {
                        this.webPlayer.prepareNext(sources['mp3']);

                        this.preloadedTrack = this.queue.items[0];
                        this.preloadedTrackUri = sources['mp3'];
                        this.preloadedFlacSupport = sources.flac != null;
                    }
                });
            }

            api.get('/listen/{{id}}', {
                id: track.id
            }, {}, (data) => {
            });

        } else {
            console.log('App: Doing listen call');
            api.get('/listen/{{id}}', {
                id: track.id
            }, {}, (data) => {
                if (data.success) {
                    var sources = data.sources;
                    if (sources[format]) {
                        this.webPlayer.changeSource(sources[format], this.root.playback.track);
                    } else {
                        this.webPlayer.changeSource(sources['mp3'], this.root.playback.track);
                    }
                    if (!stayPaused) {
                        this.webPlayer.play();
                    }

                    this.root.flacSupportedTrack = sources.flac != null;


                    if (this.notifier) {
                        this.notifier.notifyTrackPlaying(track);
                    }

                    if (this.queue.items.length > 0) {
                        api.get('/listen/{{id}}', {
                            id: this.queue.items[0].id,
                        }, {
                            type: 'preload',
                        }, (data) => {
                            var sources = data.sources;
                            if (sources[format]) {
                                this.webPlayer.prepareNext(sources[format]);

                                this.preloadedTrack = this.queue.items[0];
                                this.preloadedTrackUri = sources[format];
                                this.preloadedFlacSupport = sources.flac != null;
                            } else {
                                this.webPlayer.prepareNext(sources['mp3']);

                                this.preloadedTrack = this.queue.items[0];
                                this.preloadedTrackUri = sources['mp3'];
                                this.preloadedFlacSupport = sources.flac != null;
                            }
                        });
                    }

                } else {
                    this.webPlayer.stop();
                    this.root.flacSupportedTrack = false;

                    if (data.error == 'You have run out of free plays.') {
                        this.promptRegister();
                    }
                }
            }, () => {
                console.log('Error!');
            });
        }
        
        // if iosApi - send the rest of the queue contents
        if (iosApi.supported) {
            this.sendQueue();
        }
    }

    async sendQueue() {
        let format = this.root.playback.flac ? 'flac' : 'mp3';
        let items = await api.getQueueInfo(this.queue.items, format);
        
        if (items.length > 0) {
            console.log('sendQueue');
            console.log(items);
            this.webPlayer.sendQueue(items);
        } else {
            console.log('sendQueue failed - ran out of free plays')
        }
    }

    prevTrack(manual) {
        console.log('PREV TRACK');

        var pause = false;
        var moreTracks = this.queue.prev();
        if (!moreTracks) {
            this.queue.restart(this.root.playmode.shuffle, true);
            if (!this.root.playmode.repeat && !manual) {
                pause = true;
            }
        }

        if (this.queue.current) {
            this._loadTrack(this.queue.current, pause);

            if (pause) {
                this.webPlayer.pause();
            }
        }
    }


    nextTrack(manual) {
        console.log('NEXT TRACK');


        var pause = false;
        var moreTracks = this.queue.next();
        if (!moreTracks) {
            this.queue.restart(this.root.playmode.shuffle);
            if (!this.root.playmode.repeat && !manual) {
                pause = true;
            }
        }

        if (this.queue.current) {
            this._loadTrack(this.queue.current, pause);

            if (pause) {
                this.webPlayer.pause();
            }
        }
    }


    promptRegister() {
        this.root.showSubscribePopup = true;
    }


    init() {
        EventBus.emit('app.load', {});
    }
}



// WEBPACK FOOTER //
// ./src/App.js